import { render, staticRenderFns } from "./Sms.vue?vue&type=template&id=554ac8f0&scoped=true"
import script from "./Sms.vue?vue&type=script&lang=js"
export * from "./Sms.vue?vue&type=script&lang=js"
import style0 from "./Sms.vue?vue&type=style&index=0&id=554ac8f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554ac8f0",
  null
  
)

export default component.exports